import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";

const render = () =>
  ReactDOM.render(   
      <App />,
    document.getElementById("co2calculator-widget")
  );

render();



// WEBPACK FOOTER //
// ./src/index.js